(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcfinance.cart.factory:CartHelper
   *
   * @description
   *
   */
  angular
    .module('vcfinance.cart')
    .factory('CartHelper', CartHelper);


  CartHelper.$inject = ['Cart', '$uibModal', '$log', 'Rlog'];

  function CartHelper(Cart, $uibModal, $log, Rlog) {
    let CartHelperBase = {};

    CartHelperBase.editCart = editCart;

    function editCart(lclientid, ldiagnoses, ltest) {
      $log.debug('CartHelper.edit cart called');
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><carteditor clientid="carteCtrl.clientid"  diagnoses="carteCtrl.diagnoses" test="carteCtrl.test"></carteditor></div>',
        controllerAs: 'carteCtrl',
        controller: ['sclientid', 'sdiagnoses', 'stest', function (sclientid, sdiagnoses, stest) {
          let vm = this;
          vm.clientid = sclientid;
          vm.diagnoses = sdiagnoses;
          vm.test = stest;
          vm.cancel = cancel;

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          sclientid: function () {
            return lclientid;
          },
          stest: function () {
            return ltest;
          },
          sdiagnoses: function () {
            let flatdiagnosesarr = [];
            if (angular.isDefined(ldiagnoses) && angular.isArray(ldiagnoses)) {
              ldiagnoses.map(function (d) {
                flatdiagnosesarr.push(d.key);
              });
              return flatdiagnosesarr.join(', ');
            } else {
              return '';
            }
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    return CartHelperBase;
  }
}());
